



















import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IClearanceApproval, ClearanceApproval } from "@/models/clearance-approval.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    ConfirmActionDialog
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ClearanceApprovalChangeExpirationDialog extends mixins(PermissionMixin) implements IDialog {
  @Prop()
  value!: IClearanceApproval;

  valueCopy = new ClearanceApproval(this.value);

  isDialogActive = false;

  isUpdateLoading = false;

  open() {
    this.valueCopy = new ClearanceApproval(this.value);
    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  async confirm() {
    try {
      this.isUpdateLoading = true;
      await this.value.updatePartial({
        due: this.valueCopy.due
      });
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.isUpdateLoading = false;
    }
  }
}
